import React from "react";
import fp from "lodash/fp";
import { Row, Col } from "react-bootstrap";

import { TextWithLoader } from "components";
import { LineDivider } from "components/layout";
import { hasPermissions, permissionList } from "helpers";
import { getEntityTypeName } from "mappers";
import { BooleanTypes, ViewResidualsSplitProfilesProps } from "types";

import styles from "./../splitProfile.module.scss";

const ViewSecondarySplitInfo = ({
	loading,
	splitInfo,
	title,
	indexArray,
	secondarySplitInformation,
}: ViewResidualsSplitProfilesProps) => {
	const {
		splitPercent,
		isPrivate,
		agent,
		isUseSecondaryAgentScheduleForCalculations,
		scheduleAName,
	} = splitInfo ?? {};

	const showSplit =
		hasPermissions([permissionList.ViewPrivateResidualSplits]) ||
		!isPrivate;

	return (
		<div
			data-autotest="viewSecondarySplitInformationSection"
			className="mb-3"
		>
			<div>
				<h1 className={styles.header}>{title}</h1>
				{isPrivate && (
					<Row>
						<Col lg={6}>
							<TextWithLoader
								value="Private"
								loading={loading}
								isIconCheck
								isHideLabel
							/>
						</Col>
					</Row>
				)}
				<Row>
					<Col lg={6}>
						<TextWithLoader
							label="Agent:"
							value={agent?.name}
							loading={loading}
						/>
					</Col>
					<Col lg={{ span: 5, offset: 1 }}>
						{showSplit ? (
							<TextWithLoader
								label="Residuals Split:"
								value={
									fp.isNumber(splitPercent)
										? `${splitPercent}%`
										: ""
								}
								loading={loading}
							/>
						) : null}
					</Col>
				</Row>
				<Row>
					<Col lg={6}>
						<TextWithLoader
							label="Use Secondary Agent Schedule for Calculations:"
							value={
								BooleanTypes.getByValue(
									isUseSecondaryAgentScheduleForCalculations,
								)?.displayName
							}
							loading={loading}
						/>
					</Col>
					<Col lg={{ span: 5, offset: 1 }}>
						{scheduleAName && (
							<TextWithLoader
								label="Schedule A:"
								value={scheduleAName}
								loading={loading}
							/>
						)}
					</Col>
				</Row>
				<Row>
					<Col lg={6}>
						<TextWithLoader
							label="Entity Type:"
							value={getEntityTypeName(agent?.entityType)}
							loading={loading}
						/>
					</Col>
				</Row>
				<Row>
					<Col lg={6}>
						<TextWithLoader
							label="Partner Type:"
							value={agent?.partnerTypeDisplayName}
							loading={loading}
						/>
					</Col>
				</Row>
			</div>
			{secondarySplitInformation?.length - 1 !== indexArray && (
				<LineDivider />
			)}
		</div>
	);
};

export default ViewSecondarySplitInfo;
